import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";

import restaurantDesign from "../../Assets/Projects/restaurantDesign.png";


import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import scholarShip from "../../Assets/Projects/blog.png";
import seClub from "../../Assets/Projects/SE-CLUB1.jpg"

// Figma designs
import solverJo from "../../Assets/Figma-Designs/Demo-SolverJo-Website.jpg"
import artGo from "../../Assets/Figma-Designs/ArtGo.png"
import HFNA from "../../Assets/Figma-Designs/High-fidelity-nice-application.jpg"
import P3 from "../../Assets/Figma-Designs/Persona-3.png"
import P2 from "../../Assets/Figma-Designs/User-Persona-2.png"
import P1 from "../../Assets/Figma-Designs/User-Persona.png"
import uStory from "../../Assets/Figma-Designs/User-Story.jpg"
import hrSystem from "../../Assets/Projects/HrSystem.png"
import juniorArchitect from "../../Assets/Projects/Junior-Software-Architect.png"

//Firebolt project 
import fireboltProject from "../../Assets/Projects/Firebolt-Project.jpg"

import Button from "react-bootstrap/Button";//importing button
import { SiGmail } from "react-icons/si";//gmail icon

function Projects() {
  const gmailAddress = 'yousefghanem.linkedin@gmail.com';
  
  // Gmail compose mail URL
  const mailtoLink = `mailto:${gmailAddress}`
  const openGmail = () => {
    window.location.href = `mailto:${gmailAddress}`;
  };

  return (
    
    <Container fluid className="project-section">
      
      <Particle />
      
      <Container>
        {/* -------------------------------------------------- 2024 Projects ---------------------------------------------------- */}
      <h1 className="project-heading">
      <strong className="purple">2024 New Projects</strong>
      <p>I worked On!</p>
      </h1>
      
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={4} className="project-card">
        <ProjectCard
              imgPath={scholarShip}
              isBlog={false}
              title="Jordan Scholarship Website"
              description={
                <>
                  Cool  <strong style={{color:"violet"}}>graduating project</strong> where I led the team to deliver a nicely designed and fully functional website. <strong style={{color:"violet"}}>The Jordan Scholarship Website</strong> allows us to deal with <strong style={{color:"violet"}}>scholarship providers</strong> to <strong style={{color:"violet"}}>add</strong> their scholarships to website and <strong style={{color:"violet"}}>student seekers</strong> to <strong style={{color:"violet"}}>view</strong> avialable scholarships for them.
                  <br />
                  <br />
                  We used bunch of cool technologies such as React, Node js, firestore database and even more tp finish this amazing graduating project!
                  <br />
                  <br />
                  Technology used : React and Node.js + Firestore database + django
                </>
              }
              // ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              websiteLink="https://scolarship-website.web.app/"
              // demoLink="https://blogs.soumya-jit.tech/"
              contactLink="mailto:${yousefghanm.linkedin@gmail.com}"
              linkedInLink="https://www.linkedin.com/feed/update/urn:li:activity:7154888092699475968/"
            />
        </Col>
        <Col md={4} className="project-card">
        <ProjectCard
              imgPath={hrSystem}
              isBlog={false}
              title="HR Management System"
              description={
                <>
                  PHP project for HR Management System CodeIgniter is primarily concerned with staff tracking for the
                  company. The system also shows each category along with its corresponding details. The system also
                  enables the management of projects, salaries, assets, departments, and more. This project appears to have
                  both an admin and an employee panel. An employee has some control over the system and a modest
                  influence in the overall design of this online application.
                  <br /><br />
                  Technology used : Apache + MySql + PHP + WAMP server
                </>
              }
              youtubeLink="https://www.youtube.com/watch?app=desktop&v=hiJxIbolOco"
              userManual="https://drive.google.com/file/d/1tlBBIzfOwh5u2uo10L4VtiYs_azRhAQF/view?usp=sharing"
            />
        </Col>
        <Col md={4} className="project-card">
        <ProjectCard
              imgPath={juniorArchitect}
              isBlog={false}
              title="Junior Software Architect"
              description={
                <>
                  I applied the requirements needed from my senior, doctor fares taweel, I implemented cool technologies and diagrams as a junior software architect and gathered the requirements in excel file of mine.
                </>
              }
              
              excelFile="https://docs.google.com/spreadsheets/d/1lnSUevgPKyyVQI5GytdukxAX-TT-pQC5/edit#gid=477260324"
              reqDoc="https://drive.google.com/file/d/1u3_6b69n5uX7BnXfR-9qA7i5xkDiZLFI/view?usp=sharing"
            />
        </Col>
        </Row>       

        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are stunning <strong className="purple">Coding </strong> and <strong className="purple">Design </strong> projects I worked on!
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Little Lemon Restaurant"
              description={
                <>
                  I earned a meta <strong style={{color:"purple"}}>certificate</strong> as front-end developer with 178 hours.
                  <br /><br />
                  Thus, I designed and coded a cool <strong style={{color:"purple"}}>Little Lemon Restaurant</strong> that allows you to make a reserve! and navigate it's cool pages.
                  <br /><br />
                  Technology used: React and Node.js + Figma + Firebase
                </>
              }
              figmaLink="https://www.figma.com/file/qpFz4bUOS34zEieZokAAlF/WebsiteApplyingDesign?type=design&node-id=0%3A1&mode=design&t=FwV9Cy3rj6zZ286z-1"
              // ghLink="https://littlelemon-yg.web.app/"
              websiteLink="https://littlelemon-yg.web.app/"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Business Landing Page"
              description={
                <>
                  I had the honor to train with a german <strong style={{color:"purple"}}>KreativStorm</strong> company as front-end developer. Where my team and I managed to build a landing page 100% fits to customer needs.
                  <br />
                  <br />
                  My team and I were competitive and very fast to deliver requirements less than a week. "Senior Developer Says"
                  <br />
                  <br />
                  Technology used : Html, Css, JavaScript.
                </>
              }
              
               websiteLink="https://broccoli88.github.io/main-assignment-02/"
               ghLink="https://github.com/broccoli88/main-assignment-02"
              // demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>
          {/* Adding Software Engineering Club */}
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={seClub}
              isBlog={false}
              title="Software Engineering Club 2nd Place"
              description={
                <>
                  I have great <strong style={{color:"purple"}}>Experience</strong> designing interactive UI and UX from working as a freelancer before, where I deployed a software with eye popping UI and earned <strong style={{color:"purple"}}>100,000 downloads</strong>.

                  {/* I previously worked as a <strong style={{color:"purple"}}>Freelancer</strong> and had a software application with <strong style={{color:"purple"}}>100,000 downloads</strong> this means I professionally designed the UI and UX for this software. */}
                  <br />
                  <br />
                  From this perspective, I participated in <strong style={{color:"purple"}}>software engineering club</strong> and the competition was about making professional UI and make it interactive using <strong style={{color:"purple"}}>Figma</strong>.
                  <br />
                  <br />
                  The supervisors and dean loved ❤️ my design and in the judge day I earned the <strong style={{color:"purple"}}>2nd Place!</strong> With <strong style={{color:"orange"}}>a golden medal</strong> to share you with! 
                </>
              }

               figmaLink="https://www.figma.com/file/ofJkU6lwbGzuhAIZnhIOcQ/X-App?type=design&node-id=0-1&mode=design"
              websiteLink="https://drive.google.com/file/d/1cZoWXUrwdlzYR8PPpulUPkwANLSnSmio/view?usp=sharing"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Restaurant Checkout Design"
              description={
                <>Thinking and arranging ideas to an <strong style={{color:"purple"}}>adorable</strong> design using Figma.</>
              }
              figmaLink="https://www.figma.com/file/W1AQckrYmmuTkNvqmwHbLk/HighFidelity?type=design&node-id=0%3A1&mode=design&t=CwtSODluAh0kYgNp-1"
              //This is low fidelity one
              loveIcon="https://www.figma.com/file/qpFz4bUOS34zEieZokAAlF/WebsiteApplyingDesign?type=design&node-id=0%3A1&mode=design&t=b4WIGfEktXDTlp8z-1"
              // ghLink="https://github.com/soumyajit4419/Plant_AI"
              // demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Ai Diabetes Analysis "
              description={
                <>
                  I had the honor to train with <strong style={{color:"purple"}}>Alraja International</strong> company, the output was applying the knowledge in the best way to come out with this analysis using python.
                  <br></br><br></br>
                  This case aims to give a simple and clear clarification of applying <strong style={{color:"purple"}}>EDA</strong> in a real diabets dataset . In this case, I developed a basic changing on the data, viewing the data in <strong style={{color:"purple"}}>bar chart</strong> and <strong style={{color:"purple"}}>pie chart </strong> and other charts. I also <strong style={{color:"purple"}}>trained models </strong> to get the <strong style={{color:"purple"}}>highest</strong> predicting scores!
                  
                  <br /><br />
                  The supervisor data scientist loved ❤️ my work, and I was awareded with a degree and 500 USD at the end of that.
                </>
              }
              //ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              websiteLink="https://www.kaggle.com/code/yoseefghanem/diabets-analysis-and-predictive-models?scriptVersionId=129960298"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fireboltProject}
              isBlog={false}
              title="Firebolt smart watches - Self Project"
              description={<>
                This project almost a masterpiece, because <strong style={{color:"purple"}}> UI & UX</strong> applied <strong style={{color:"purple"}}>Professionally</strong> Previously I made similar app like this and earned <strong style={{color:"purple"}}>100,00 </strong> downloads!
                <br /><br />
                Technology used: Online Coding Platform.
                </>}
                websiteLink= "https://play.google.com/store/apps/details?id=com.fireboltsmartwatches.smartappwatch.app&hl=en"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={restaurantDesign}
              isBlog={false}
              title="Restaurant Design Little Lemon"
              description={<>
                Wait a second chef, let me show you a <strong style={{color:"purple"}}>Mobile</strong> and <strong style={{color:"purple"}}>Web </strong> cool designs for the restaurant!
              </>}
              figmaLink="https://www.figma.com/file/QpyKovEfFcY7Qzd4vy4MwU/Little-Lemon-Prototypes?type=design&node-id=0%3A1&mode=design&t=Lxyg4bcoSkQCfcmp-1"

              loveIcon="https://www.figma.com/file/qpFz4bUOS34zEieZokAAlF/WebsiteApplyingDesign?type=design&node-id=0-1&mode=design&t=G2elYJMpqYCXkNtX-0"
              // ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>
          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="Face Recognition and Emotion Detection"
              description=""
              // ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col> */}
        
        <h1 className="project-heading">
          Extra Cool Figma <strong className="purple"> Designs</strong>
        </h1>
        <p style={{ color: "white" }}>
          Let's arrange a meeting to <strong className="purple">Discuss </strong> the alignment of my skills to your <strong className="purple">Company </strong>
        </p>
        {/* <Button
            onClick={openGmail}
            variant="primary"
            target="_blank"
            style={{ maxWidth: "250px" }}
          >
            <SiGmail />
            &nbsp;Contact Now
        </Button> */}
                
        </Row> 
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={artGo}
              isBlog={false}
              title="ArtGo UI/UX app"
              description={
                <>
                  Cool place that combines <strong style={{color:"purple"}}>Art, Crafts, Food</strong> all together!

                  This cool UI/UX includes more than 40 well designed screens!
                  <br></br>
                  You can run the prototype in figma, to see cool 
                  <strong style={{color:"orange"}}> interactions</strong> between the screens.
                  
                </>

              }
              figmaLink="https://www.figma.com/file/NbyBfpvg5nGWsMMhEqwRTx/ArtGo-MyMission?type=design&node-id=0-1&mode=design&t=qTTePGfMMQsKbQz1-0"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={solverJo}
              isBlog={false}
              title="Demo SolverJo Website"
              description={
                <>
                  Nice solverJo website with <strong style={{color:"purple"}}>low + high fidelity</strong> design
                </>
              }
              figmaLink="https://www.figma.com/file/zRey7khqIMEJHZktZnxe3U/Demo-SolverJo-Website?type=design&node-id=0%3A1&mode=design&t=PuCTPZ4spslKCAgo-1"
              // ghLink="https://littlelemon-yg.web.app/"
              // websiteLink="https://littlelemon-yg.web.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={HFNA}
              isBlog={false}
              title="High fidelity nice application"
              description={
                <>
                  Nice High fidelity application, almost as an <strong style={{color:"purple"}}>Image Gallery</strong> design.
                </>
              }
              figmaLink="https://www.figma.com/file/vSkskdKJcupAOTumewywog/High-fidelity-nice-application?type=design&node-id=0%3A1&mode=design&t=MkVw6c8xskmaVeN5-1"
              // ghLink="https://littlelemon-yg.web.app/"
              // websiteLink="https://littlelemon-yg.web.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={P3}
              isBlog={false}
              title="Steve Rogers"
              description={
                <>
                  Steve is <strong style={{color:"purple"}}>gentle man</strong>, this persona has made <strong style={{color:"purple"}}>90% ROI</strong> take a look at it!
                </>
              }
              figmaLink="https://www.figma.com/file/aTxnQVOt9ib90Ia9vH7mC6/Steve-Gentle-Persona?type=design&node-id=0%3A1&mode=design&t=AaSxBU7OVw4HF6Nd-1"
              // ghLink="https://littlelemon-yg.web.app/"
              // websiteLink="https://littlelemon-yg.web.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={P2}
              isBlog={false}
              title="Jhon Persona"
              description={
                <>
                  Jhon is a <strong style={{color:"purple"}}>Fictional</strong> persona, he has some <strong style={{color:"purple"}}>interests</strong> to share it with you!
                </>
              }
              figmaLink="https://www.figma.com/file/UrGOkVoo3vvuH7jYo149Gf/Jhon-Persona?type=whiteboard&node-id=0%3A1&t=V32eYkjQvb8m1Zka-1"
              // ghLink="https://littlelemon-yg.web.app/"
              // websiteLink="https://littlelemon-yg.web.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={P1}
              isBlog={false}
              title="User Persona Jacky"
              description={
                <>
                  Jacky is a fictional <strong style={{color:"purple"}}>Product Manager</strong> , He is happy that I <strong style={{color:"purple"}}>designed</strong> this persona for him!
                </>
              }
              figmaLink="https://www.figma.com/file/n21LK3wNCNtj0sOIySmCta/User-Persona-Jacky?type=design&node-id=0%3A1&mode=design&t=8IHVElgpAfJJKCjD-1"
              // ghLink="https://littlelemon-yg.web.app/"
              // websiteLink="https://littlelemon-yg.web.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={uStory}
              isBlog={false}
              title="User Story"
              description={
                <>
                  Here's a <strong style={{color:"purple"}}>User Story</strong> , simulating how he's <strong style={{color:"purple"}}>thinking</strong> to build his website!
                </>
              }
              figmaLink="https://www.figma.com/file/Pjv54D04jRDUeStcZaOJab/User-Stories-(Community)?type=whiteboard&node-id=9%3A2&t=mmOuBaU2AjBWaRq4-1"
              // ghLink="https://littlelemon-yg.web.app/"
              // websiteLink="https://littlelemon-yg.web.app/"
            />
          </Col>
          </Row>
      </Container>
    </Container>
  );
}

export default Projects;
